<div class="congrats_container_desktop">
    <div class="confirmation-title" data-automation-label="Confirmation-Title">
        Congrats! Taxes just got easier.
    </div>
    <div *ngIf="preOrderEnabled; else elsePreOrder" class="confirmation-subtitle pre-order" data-automation-label="Confirmation-SubTitle">
        We've emailed you a copy of your receipt to <span class="bold">{{email}}</span>. We'll charge your card and 
        send you a confirmation email when {{product}} becomes available.
    </div>
    <ng-template #elsePreOrder>
        <div class="confirmation-subtitle" data-automation-label="Confirmation-SubTitle">
            We've emailed you a copy of your receipt to <span class="bold">{{email}}</span> and a link to download your software.
        </div>
    </ng-template>
</div>
<div class="congrats_container_mobile">
    <div class="confirmation-title" data-automation-label="Confirmation-Mobile-Title">
        Congrats! Taxes just got easier.
    </div>
    <div *ngIf="preOrderEnabled; else elsePreOrder" class="confirmation-subtitle" data-automation-label="Confirmation-Mobile-SubTitle">
        We've emailed you a copy of your receipt to <span class="bold">{{email}}</span>. We'll charge your card and 
        send you a confirmation email when {{product}} becomes available.
    </div>
    <ng-template #elsePreOrder>
        <div class="confirmation-subtitle" data-automation-label="Confirmation-Mobile-SubTitle-0">
            We've emailed you a copy of your receipt to <span class="bold">{{email}}</span> and a link to download your software.
        </div>
        <div class="confirmation-subtitle" data-automation-label="Confirmation-Mobile-SubTitle-1">
            Follow the instructions in the email to install the software on your computer and start your taxes.
        </div>
    </ng-template>
    <hr/>
</div>
<div class="left-container">
    <div [hrblockMicroAppLoader]="OrderConfirmation" ></div>
</div>
